import type { Ref, TextareaHTMLAttributes } from 'react';
import { cx } from '../internal/cx';
import { useFieldProps } from './fieldContext';
import styles from './Form.module.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  resize?: 'vertical' | 'none';
  ref?: Ref<HTMLTextAreaElement>;
}

export function Textarea({
  invalid,
  resize = 'vertical',
  className,
  id,
  required,
  disabled,
  rows = 4,
  'aria-describedby': ariaDescribedBy,
  ref,
  ...rest
}: TextareaProps) {
  const field = useFieldProps({
    id,
    'aria-describedby': ariaDescribedBy,
    invalid,
    required,
    disabled,
  });
  return (
    <textarea
      ref={ref}
      id={field.id}
      rows={rows}
      className={cx(
        styles.textarea,
        field.invalid && styles.controlInvalid,
        resize === 'none' && styles.noResize,
        className,
      )}
      aria-describedby={field.describedBy}
      aria-invalid={field.invalid || undefined}
      required={field.required || undefined}
      disabled={field.disabled || undefined}
      {...rest}
    />
  );
}
